import React from 'react';
import ServiceList from './ServiceList';

function ServiceTabs() {
    return <ServiceList />;
}

export default React.memo(ServiceTabs);
